import { useQuery } from "@tanstack/react-query";
import { documentRelationshipsApi } from "@/api/documentRelationships";

export function useDocumentRelationships(documentId: string | null | undefined) {
  return useQuery({
    queryKey: ["document-relationships", documentId],
    enabled: !!documentId,
    queryFn: () => documentRelationshipsApi.list(documentId!),
  });
}
